const openaiHost = 'api.openai.com'

/**
 * Create OpenAI API request function
 * @param {Function} httpRequest - HTTP request function
 * @returns {Function} requestAPI function bound to the httpRequest
 */
export function createRequestAPI(httpRequest) {
  return async ({ host = openaiHost, path, method = 'POST', body = {}, apiKey }) => {
    if (!apiKey) {
      throw new Error('apiKey is required for OpenAI API calls')
    }

    const options = {
      protocol: 'https',
      options: {
        host,
        path,
        method,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${apiKey}`,
        },
      },
      data: method === 'POST' || method === 'PUT' ? JSON.stringify(body) : '',
      timeout: 60000,
    }

    const resp = await httpRequest(options)

    if (resp.statusCode >= 400) {
      throw new Error(
        `OpenAI API error: ${resp.statusCode} - ${JSON.stringify(resp.body)}`,
      )
    }

    return JSON.parse(resp.body)
  }
}
